<script>
import { uniqBy, groupBy } from 'lodash'
import { Errors } from 'form-backend-validation'

export default {
  name: 'scoreComponentEntry',
  props: ['value', 'studentScoreAndComponent', 'gradeSubjects', 'validate'],
  data() {
    return {
      errors: new Errors(),
      reload: false,
      model: {},
      newSubjects: [],
      subjectItemList: {}
    }
  },
  created() {
    this.model = this.value
    this.createNewSubjectList()
    this.createSubjectItem()
  },
  computed: {
    subjectIdValue: () => score => {
      const flatten = Object.values(score).flat()
      if (flatten.length) {
        return flatten[0].new_subject_id
      }
      return null
    },
    subjectItemIdValue: () => items => {
      if (items.length) {
        return items[0].new_subject_comp_id
      }
      return null
    },
    getSubjectItemList: vm => items => {
      if (items !== undefined) {
        if (items.length && items[0].new_subject_id) {
          return vm.subjectItemList[items[0].new_subject_id]
        }
      }
      return []
    },
    subItemsList: vm => item => {
      if (item !== undefined) {
        return vm.gradeSubjects.filter(
          gs =>
            gs.subject_id === item.new_subject_id &&
            gs.subject_comp_id === item.new_subject_comp_id
        )
      }
      return []
    }
  },
  methods: {
    createNewSubjectList() {
      const subjects = uniqBy(
        this.gradeSubjects.map(el => ({
          subject_id: el.subject_id,
          subject_name_native: el.subject_name_native
        })),
        'subject_id'
      )
      this.newSubjects = subjects
    },
    createSubjectItem() {
      const subjectItem = uniqBy(
        this.gradeSubjects.map(el => ({
          ux: `${el.subject_comp_id}_${el.subject_id}`,
          subject_id: el.subject_id,
          comp_item_name: el.comp_item_name,
          subject_comp_id: el.subject_comp_id
        })),
        'ux'
      )
      this.subjectItemList = groupBy(subjectItem, 'subject_id')
    },
    onSubjectChange(event, subjectItems) {
      const subjectId = event.target.value
      const keyItem = Object.keys(subjectItems)
      keyItem.forEach(key => {
        subjectItems[key].forEach(el => {
          // find subject
          const subjects = this.gradeSubjects.filter(
            s => s.subject_id === parseInt(subjectId)
          )
          if (subjects.length) {
            el.new_subject_id = subjects[0].subject_id

            // find subject component
            const components = subjects.filter(
              com => com.comp_item_name === el.display_subject_comp
            )

            if (components.length) {
              el.new_subject_comp_id = components[0].subject_comp_id

              // sub item
              const subItem = components.find(
                sub =>
                  sub.subject_comp_item_detail_name ===
                  el.display_subject_comp_detail
              )

              if (subItem !== undefined) {
                el.new_subject_comp_detail_id = parseInt(
                  subItem.subject_comp_detail_id
                )
              }
            } else {
              el.new_subject_comp_id = ''
              el.new_subject_comp_detail_id = ''
            }
          } else {
            el.new_subject_id = ''
            el.new_subject_comp_id = ''
            el.new_subject_comp_detail_id = ''
          }
        })
      })
      this.reload = true
      this.$nextTick(() => (this.reload = false))
    },
    onSubjectItemChange(event, items) {
      const itemId = parseInt(event.target.value)

      const components = this.gradeSubjects.filter(
        s =>
          s.subject_id === parseInt(items[0].new_subject_id) &&
          s.subject_comp_id === itemId
      )

      items.forEach(el => {
        if (components.length) {
          el.new_subject_comp_id = components[0].subject_comp_id
          // sub item
          const subItem = components.find(
            sub =>
              sub.subject_comp_item_detail_name ===
              el.display_subject_comp_detail
          )

          if (subItem !== undefined) {
            el.new_subject_comp_detail_id = parseInt(
              subItem.subject_comp_detail_id
            )
          }
        } else {
          el.new_subject_comp_id = ''
          el.new_subject_comp_detail_id = ''
        }
      })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<template>
  <div v-if="!reload">
    <h3 class="ts-uppercase ts-font-semibold ts-text-blue-800 ts-text-base">
      {{ $t('studentTransfer.scoreComponentEntry') }}
    </h3>
    <div class="ts-mt-2">
      <div
        v-for="(score, subject) in model.scoreComponentEntries"
        :key="subject"
        class="ts-border-t ts-py-2"
      >
        <div class="ts-flex ts-items-center ts-space-x-3">
          <div style="width: 12.4rem;">
            <h4 class="ts-text-base">{{ subject }}</h4>
          </div>
          <i class="fas fa-arrow-right"></i>
          <div>
            <select
              :value="subjectIdValue(score)"
              class="ts-outline-none"
              @change="value => onSubjectChange(value, score)"
            >
              <option value="">--select--</option>
              <option
                v-for="(sub, index) in newSubjects"
                :key="index"
                :value="sub.subject_id"
                >{{ sub.subject_name_native }}</option
              >
            </select>
          </div>
        </div>
        <div class="ts-mt-2">
          <div
            v-for="(items, componentName) in score"
            class="ts-border-t ts-p-2"
          >
            <div class="ts-flex ts-items-center ts-space-x-3">
              <div style="width: 11.9rem;">
                <p class="ts-mb-0 ts-text-blue-600 ts-font-semibold">
                  {{ componentName }}
                </p>
              </div>
              <i class="fas fa-arrow-right"></i>
              <select
                :value="subjectItemIdValue(items)"
                class="ts-outline-none"
                @change="event => onSubjectItemChange(event, items)"
              >
                <option value="">--Select--</option>
                <option
                  v-for="(itemList, index) in getSubjectItemList(items)"
                  :key="index"
                  :value="itemList.subject_comp_id"
                  >{{ itemList.comp_item_name }}</option
                >
              </select>
            </div>
            <div class="ts-flex ts-flex-wrap">
              <div
                v-for="(componentItem, index) in items"
                :key="index"
                class="ts-ml-2 ts-mt-2"
              >
                <div
                  class="ts-border ts-p-1 ts-rounded ts-flex ts-whitespace-no-wrap ts-items-center ts-space-x-3"
                >
                  <p class="ts-mb-0 ts-text-gray-500">
                    {{ componentItem.display_subject_comp_detail }}
                  </p>
                  <i class="fas fa-arrow-right ts-text-xs ts-text-gray-500"></i>
                  <div>
                    <select
                      v-model="componentItem.new_subject_comp_detail_id"
                      class="ts-outline-none ts-w-full"
                    >
                      <option value="">-</option>
                      <option
                        v-for="(comItem, index) in subItemsList(componentItem)"
                        :key="index"
                        :value="comItem.subject_comp_detail_id"
                        >{{ comItem.subject_comp_item_detail_name }}</option
                      >
                    </select>
                  </div>
                </div>
                <div
                  class="ts-text-red-500"
                  v-if="errors.has(
                      `scoreComponentEntries.${subject}.${componentName}.${index}.new_subject_comp_detail_id`
                    )"
                >
                  {{
                    errors.first(
                      `scoreComponentEntries.${subject}.${componentName}.${index}.new_subject_comp_detail_id`
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
select {
  /* Remove default arrow in IE/Edge */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
